import React from "react";

const AboutPage = () => {
    return (
        <div
            style={{
                margin: 64,
                padding:32,
                borderRadius:16,
                textAlign: "center",
                fontSize: 18
            }}
        >
            Should you have any questions or feedback, please contact <a href='mailto:rio@sfu.ca'>rio@sfu.ca</a>
        </div>
    )
};

export default AboutPage;